import React from "react";
import { MdSearch } from "react-icons/md";

const SearchBox = ({
    value,
    onChange,
    placeholder = "Search",
    className = "",
    inputClassName = "",
    iconSize = 22,
}) => {
    return (
        <div className={`relative ${className}`}>
            <MdSearch
                size={iconSize}
                className="absolute left-3 top-1/2 -translate-y-1/2 textlight"
            />

            <input
                type="text"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={`w-full pl-9 pr-3 py-2 border border-[#D9D9D9] textblack rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#1976D2] focus:border-[#1976D2] transition ${inputClassName}`}
            />
        </div>
    );
};

export default SearchBox;
